import {ProductFilter} from "../../domain/dtos/product-filter";

export class ProductFilterMapper {
    static deserialize(param: any): ProductFilter {
        return {
            name: param.name,
            code: param.code,
            type: param.type,
            order: param.order,
            selected: param.selected,
            isFeatured: param.outstanding,
            isMultiselect: !param.filterUnique,
        }
    }
}
